module.exports = __webpack_public_path__ + "ad5e2ac2d011f3837163cc3493850874.svg";